module.exports = "/**\n * 演示文件，可删除\n * @type {number}\n */\nvar xxx1 = 111;"